import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { translate } from '@jsverse/transloco';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Constants } from 'src/app/models/constants';
import { EnvScheduleService } from 'src/app/services/api/env-schedule.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { filter, switchMap, tap } from 'rxjs';


@Component({
  selector: 'app-environment-scheduler-component-update',
  templateUrl: './environment-scheduler-component-update.component.html',
  styleUrls: ['./environment-scheduler-component-update.component.scss'],
  standalone: false
})
export class SchedulerComponentUpdateComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() data: any;
  componentVersionUpdateForm!: FormGroup;

  title!: string;
  name!: string;
  currentVersion!: string;
  versions: any;
  instanceId: string;


  Constants = Constants;

  constructor(
    public activatedRoute: ActivatedRoute,
    public sidenavService: SidenavService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private envScheduleService: EnvScheduleService,
    public toastrService: CustomToastrService
  ) { }


  ngOnInit(): void {
    this.title = translate('UPDATE_MANAGER.SCHEDULER_COMPONENT_VERSION_UPDATE');
    this.initViewData();
    this.createForm();
  }
  //initializes the form data
  private initViewData(): void {
   if (this.data) {
      this.name = this.data.name;
      this.currentVersion = this.data.currentVersion;
      this.versions = this.data.versions || [];
      this.instanceId = this.data.instanceId;
    }
  }
  //Creates the form fields and adds validation
  private createForm(): void {
    this.componentVersionUpdateForm = this.fb.group({
      name: [{ value: this.name, disabled: true }],
      currentVersion: [{ value: this.currentVersion, disabled: true }],
      version: [
        '',
        Validators.required
      ]
    });
  }
  //Perform validation and shows confirmation popup
  confirmSubmit(): void {
    if (this.componentVersionUpdateForm.invalid) {
      this.componentVersionUpdateForm.markAllAsTouched();
      return;
    }

    this.dialog
      .open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('UPDATE_MANAGER.SCHEDULER_COMPONENT_VERSION_UPDATE'),
          message: translate('UPDATE_MANAGER.UPDATE_CONFIRMATION', { componentName: this.name }),
          confirmButtonText: translate('DIALOG.CONFIRM')
        }
      })
      .afterClosed()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter(confirm => confirm),
        tap(() => this.sidenavService.closeRightSidenav({ updated: true })),
        switchMap(() =>
          this.envScheduleService.putSchedulerComponents(
            this.instanceId,
            this.componentVersionUpdateForm.value.version
          )
        )
      )
      .subscribe({
        next: data => {
          if (data?.httpStatusCode === 202) {
            setTimeout(() => {
              const title = translate('UPDATE_MANAGER.SCHEDULER_COMPONENT_VERSION_UPDATE');
              const message = translate('UPDATE_MANAGER.ENV_SCHEDULER_UPDATE_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
          }
        },
        error: error => this.openErrorDialog(error)
      });
  }

  //Show the error dialog upon any failure
  openErrorDialog(error: any): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('SCHEDULE_DETAILS.SCHEDULE_VALIDATION_ERROR'),
        descriptionError: error
      }
    });
  }
}
